import { Link } from 'react-router-dom';
import { HighlightText, PhoneVideoMockup, StepRow, StepCard, SocialCard, CollapseButton } from './DigitalAdministrationPage';
import { useEffect, useState } from 'react';  
import { PiCaretUpBold, PiCaretDownBold } from "react-icons/pi";

export default function DigitalAdministrationInstructorPage() {
    const [openSection, setOpenSection] = useState(null); // For track the button that is selected

    const handleSectionToggle = (section) => {
        // Change between sections
        setOpenSection(section);
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, []);

    return (
        <div className="bg-gradient-to-r from-slate-900 via-cyan-900 to-sky-300 min-h-screen">
            <div
                className={'w-full flex flex-col min-h-screen'} 
                style={{
                    backgroundImage: 'url(/assets/images/background/pattern-opacity.png)',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center top',
                }}
            >
                <div className='flex flex-col gap-8 container mx-auto px-site py-site text-white'>
                    <div className="w-full flex flex-col gap-16 text-center">
                        {/* Header Section */}
                        <div className="flex flex-col xl:flex-row gap-4 justify-center">
                            {/* Left Section: Text */}
                            <div className="flex flex-col justify-center items-center gap-8">
                                <h1 
                                    className="font-display font-bold text-2xl sm:text-4xl md:text-5xl whitespace-nowrap "
                                >
                                    Sok idődet elveszi
                                    <br />
                                    az ügyintézések miatti{' '}
                                    <br />
                                    <HighlightText path="/assets/images/doq_landing/utazas_es_varakozas_alter.svg">utazás és várakozás?</HighlightText>
                                </h1>
                                <b className="font-display font-black block text-xs sm:text-lg md:text-xl">
                                    Digitális megoldásával időt spórol neked a Fürge Diák!
                                </b>
                                <p className="font-display max-w-md mx-auto text-[0.7rem] sm:text-sm md:text-lg">
                                    Kattints és részletesen megmutatjuk hogyan tudsz pár lépésben
                                    <br/>
                                    elektronikusan dokumentumot aláírni és beküldeni Iskolaszövetkezetünknek!
                                    <br/>
                                    <br/>
                                    A Fürge Diákkal személyes megjelenés nélkül, bárhonnan szerződhetsz
                                    <br/>
                                    digitálisan. Sőt, bármilyen diákmunka vállaláshoz szükséges dokumentumot is
                                    <br/>
                                    küldhetsz digitálisan.
                                </p>
                                {/* Registration Button */}
                                <div
                                    className="font-display px-4 py-2 gradient-button-instructor text-white rounded-xl shadow-2xl hover:shadow-xl 
                                                hover:scale-105 transform transition duration-300 ease-in-out hover:ring-8 ring-white/20
                                                whitespace-nowrap text-[0.7rem] sm:text-sm md:text-lg"
                                >
                                    <Link
                                        className='flex gap-2 justify-center items-center'
                                        to="#content"
                                        onClick={(e) => {
                                            e.preventDefault();

                                            document.getElementById('content')?.scrollIntoView({
                                                behavior: 'smooth',
                                            });
                                        }}
                                    >
                                        <PiCaretDownBold className='text-2xl' />
                                        Görgess tovább!
                                    </Link>
                                </div>
                            </div>

                            {/* Right Section: Image */}
                            <div className="flex justify-center items-center">
                                <img
                                    src="/assets/images/doq_landing/kep1_alter_desktop.png"
                                    alt="Background Picture"
                                    className="size-[320px] md:size-[560px] object-contain"
                                />
                            </div>
                        </div>
                        <div id='content' className="flex flex-col gap-16 w-full justify-center items-center text-center">
                            <div className='flex flex-col gap-4'>
                                <h1 className="font-display font-bold text-2xl sm:text-4xl md:text-5xl">
                                    <HighlightText path="/assets/images/doq_landing/utazas_es_varakozas_alter.svg">Hogyan használd</HighlightText>
                                    <br/>
                                    a DOQDrive Next felületét?
                                </h1>
                                <b className="text-white font-display font-black block text-xs sm:text-lg md:text-xl">
                                    A folyamat nagyon egyszerű!
                                </b>
                                <p className="font-display text-white mt-4 md:mt-0 max-w-md mx-auto md:px-16 text-[0.7rem] sm:text-sm md:text-lg">
                                    Válaszd ki, hogy melyik művelet érdekel és már mutatjuk is a lépéseket!
                                </p>
                                <div className="flex flex-col items-center md:flex-row md:justify-center gap-4">
                                    {/* Signing a Document */}
                                    <button
                                        className={`w-full md:w-1/2 font-display px-4 py-2 flex justify-center
                                                    ${openSection === 'sign' ? 'bg-gradient-to-r from-yellow-400 to-orange-400' : 'gradient-button-instructor'}
                                                    text-white rounded-xl shadow-2xl whitespace-nowrap hover:ring-8 ring-white/20
                                                    text-[0.7rem] sm:text-sm md:text-lg hover:shadow-lg
                                                    transform transition duration-300 ease-in-out`}
                                        onClick={() => handleSectionToggle('sign')}
                                    >
                                        Dokumentum aláírása
                                    </button>

                                    {/* Submitting a Document Button */}
                                    <button
                                        className={`w-full md:w-1/2 font-display px-4 py-2 flex justify-center
                                                    ${openSection === 'submit' ? 'bg-gradient-to-r from-yellow-400 to-orange-400' : 'gradient-button-instructor'}
                                                    text-white rounded-xl shadow-2xl whitespace-nowrap hover:ring-8 ring-white/20
                                                    text-[0.7rem] sm:text-sm md:text-lg hover:shadow-lg
                                                    transform transition duration-300 ease-in-out`}
                                        onClick={() => handleSectionToggle('submit')}
                                    >
                                        Dokumentum beküldése
                                    </button>
                                </div>
                            </div>

                            <div>
                                <div
                                    className={`overflow-hidden transition-all duration-1000 ease-in-out pb-4 ${
                                        openSection === 'sign'
                                            ? 'max-h-fit opacity-100 translate-y-0'
                                            : 'max-h-0 opacity-0 -translate-y-4'
                                    }`}
                                >
                                    <div className='flex flex-col items-center gap-16 w-full'>
                                        <PhoneVideoMockup videoSrc="/assets/video/3.mp4" />
                                        <div className="w-full max-w-6xl flex flex-col gap-8">
                                            <StepRow number={1} background="/assets/images/doq_landing/lepesek_desktop_alter.svg">
                                                <StepCard
                                                    icon="/assets/images/doq_landing/16.svg"
                                                    title="E-mail értesítőd érkezik, lépj be DOQDrive Next fiókodba!"
                                                >
                                                    Amennyiben aláírásra küldünk Neked egy dokumentumot, e-mailes értesítést fogsz kapni.
                                                    Lépj be DOQDrive Next fiókodba az applikáción vagy a <Link to={`https://app.doqdrive.com/`} className='hover:underline'>https://app.doqdrive.com/</Link> weboldalon keresztül.
                                                </StepCard>
                                            </StepRow>

                                            <StepRow number={2} reverse background="/assets/images/doq_landing/lepesek_desktop_alter.svg">
                                                <StepTwoRow />
                                            </StepRow>
                                        </div>
                                        <CollapseButton
                                            buttonColor="instructor"
                                            onClick={() => {
                                                setOpenSection(null);

                                                setTimeout(() => {
                                                    document.getElementById('content')?.scrollIntoView({
                                                        behavior: 'smooth',
                                                        block: 'start',
                                                    });
                                                }, 100);
                                            }}
                                        />
                                    </div>
                                </div>

                                <div
                                    className={`overflow-hidden transition-all duration-700 ease-in-out pb-4 ${
                                        openSection === 'submit'
                                            ? 'max-h-fit opacity-100 translate-y-0'
                                            : 'max-h-0 opacity-0 -translate-y-4'
                                    }`}
                                >
                                    <div className="flex flex-col items-center gap-16 w-full">

                                        <PhoneVideoMockup videoSrc="/assets/video/2.mp4" />

                                        <div className="w-full max-w-6xl flex flex-col gap-8">
                                            <StepRow number={1} background="/assets/images/doq_landing/lepesek_desktop_alter.svg">
                                                <StepCard
                                                    icon="/assets/images/doq_landing/13.svg"
                                                    title="Lépj be DOQDrive Next fiókodba applikáción keresztül!"
                                                />
                                            </StepRow>

                                            <StepRow number={2} reverse background="/assets/images/doq_landing/lepesek_desktop_alter.svg">
                                                <StepCard
                                                    icon="/assets/images/doq_landing/14.svg"
                                                    title="Fényképezd le a beküldeni kívánt dokumentumot!"
                                                >
                                                    A belépett felület alsó sorában klikkelj a kamera ikonra és válaszd a <strong>hiteles kép</strong> opciót. Az
                                                    app megnyitja a telefonod kameráját. Fotózd le a beküldeni kívánt dokumentumot. Ha több
                                                    oldala van, akkor klikkelj az <strong>új oldal</strong> gombra és fotózd le a másik oldalt is. Ha kész vagy,
                                                    kattints a <strong>hitelesítés</strong> gombra, válaszd a <strong>hiteles kép</strong> dokumentumtípust és nevezd el a fájlt.
                                                    Az OK gomb után az index adatokat nem kötelező megadnod, egyből választhatod a <strong>hitelesítés</strong> gombot.
                                                </StepCard>
                                            </StepRow>

                                            <StepRow number={3} background="/assets/images/doq_landing/lepesek_desktop_alter.svg">
                                                <StepCard
                                                    icon="/assets/images/doq_landing/15.svg"
                                                    title="Küldd be a dokumentumot!"
                                                >
                                                    Kattints az ugrás a dokumentumokhoz gombra és válaszd ki a feltöltött fájlt. Nyomd meg a
                                                    küldés gombot és add meg címzett partnerként a Fürge Diák Postát. Írd be a dokumentum
                                                    nevét a tárgy mezőbe és kattints a küldés gombra. Ezzel a dokumentum beküldése
                                                    sikeresen megtörtént. A dokumentum beérkezésének várható ideje 1 nap.
                                                </StepCard>
                                            </StepRow>
                                        </div>
                                        <CollapseButton
                                            buttonColor="instructor"
                                            onClick={() => {
                                                setOpenSection(null);

                                                setTimeout(() => {
                                                    document.getElementById('content')?.scrollIntoView({
                                                        behavior: 'smooth',
                                                        block: 'start',
                                                    });
                                                }, 100);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        <div className="flex flex-col gap-4 w-full justify-center items-center text-center">
                            <h1 className="font-display font-bold text-2xl sm:text-4xl md:text-5xl">
                                <HighlightText path="/assets/images/doq_landing/mar_van_alter.svg">Nincs még</HighlightText>
                                <br/>
                                DOQDrive Next
                                <br/>
                                regisztrációd?
                            </h1>
                            <b className="text-white font-display font-black block text-xs sm:text-lg md:text-xl">
                                Nem tudod, hogy mire használhatod?
                            </b>
                            <p className="font-display text-white mt-4 md:mt-0 max-w-md mx-auto md:px-16 text-[0.7rem] sm:text-sm md:text-lg">
                                Kattints ide, mutatjuk a tudnivalókat és a lépéseket!
                            </p>
                            <div
                                className="font-display px-4 py-2 gradient-button-instructor text-white rounded-xl shadow-2xl hover:shadow-xl 
                                            hover:scale-105 transform transition duration-300 ease-in-out hover:ring-8 ring-white/20
                                            whitespace-nowrap text-[0.7rem] sm:text-sm md:text-lg"
                            >
                                <Link to={'/digitalis-ugyintezes'} >
                                    DOQDrive regisztráció
                                </Link>
                            </div>

                            <div className="flex flex-col xl:flex-row gap-4 justify-center px-4 py-8">
                                {/* Left Section: Text */}
                                <div className="flex flex-col gap-8 justify-center items-center w-full xl:w-1/2 text-center">
                                    <h1 className="font-display text-xl sm:text-2xl md:text-3xl font-bold">
                                        Ha mindennel elkészültél...
                                    </h1>
                                    <h1 className="font-display font-bold text-2xl sm:text-4xl md:text-5xl">
                                        Élvezd a digitális
                                        <br />
                                        ügyintézés által
                                        <br />
                                        <span
                                            className="relative inline-block"
                                            style={{
                                                backgroundImage: 'url(/assets/images/doq_landing/felszabadult_idot_alter.svg)',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center',
                                                backgroundSize: 'cover',
                                                padding: '5px 10px', 
                                                display: 'inline-block',
                                            }}
                                        >
                                            felszabadult időt!
                                        </span>
                                    </h1>
        
                                    {/* Registration Button */}
                                    <Link 
                                        to={'/diakmunka'}
                                        className="font-display px-4 py-2 gradient-button-instructor text-white rounded-xl shadow-2xl hover:shadow-xl 
                                                        hover:scale-105 transform transition duration-300 ease-in-out hover:ring-8 ring-white/20
                                                        whitespace-nowrap text-[0.8rem] sm:text-sm md:text-lg"
                                    >
                                        Nézz körül diákmunkáink között!
                                    </Link>
        
                                    <div className="flex flex-row gap-4 justify-center">
                                    {/* Facebook Button */}
                                        <SocialCard to="https://www.facebook.com/furgediak" hoverColor="instructor" icon="/assets/images/doq_landing/11_alter.svg">
                                            Kövess minket<br />Facebookon!
                                        </SocialCard>
        
                                        {/* Instagram Button */}
                                        <SocialCard to="https://www.instagram.com/furge.diak" hoverColor="instructor" icon="/assets/images/doq_landing/12_alter.svg">
                                            Kövess minket<br />Instagramon!
                                        </SocialCard>
                                    </div>
                                </div>
        
                                {/* Right Section: Image */}
                                <div className="flex justify-center items-center">
                                    <img
                                        src="/assets/images/doq_landing/kep2_alter.png"
                                        alt="Background Picture"
                                        className="size-[320px] md:size-[560px] object-contain"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function StepTwoRow() {
    const [openCards, setOpenCards] = useState({
        card1: false,
        card2: false,
    });

    const toggleCard = (cardKey) => {
        setOpenCards((prev) => ({
            ...prev,
            [cardKey]: !prev[cardKey],
        }));
    };

    return (
        <div className="flex flex-col lg:flex-row items-start justify-center gap-8">
            <StepExpandableCard
                icon="/assets/images/doq_landing/17.svg"
                title="Applikáción keresztül szeretnél aláírni"
                isOpen={openCards.card1}
                onToggle={() => toggleCard('card1')}
            >
                Amennyiben aláírásra küldünk neked egy dokumentumot, e-mailes értesítést fogsz kapni.
                Lépj be a DOQDrive fiókodba. Klikkelj a képernyő alján található <b>Mappák</b> menüpontra,
                majd a <b>Függőben lévő szerződésekre</b>, és válaszd ki az aláírásra váró dokumentumot.
                Olvasd át a kapott anyagot és ha mindent rendben találsz, akkor klikkelj a lap alján az
                <b> Aláírás</b> gombra. A szerződést ezzel sikeresen aláírtad!
            </StepExpandableCard>

            <StepExpandableCard
                icon="/assets/images/doq_landing/18.svg"
                title="Webes felületen szeretnél aláírni"
                isOpen={openCards.card2}
                onToggle={() => toggleCard('card2')}
            >
                A webes bejelentkezett felületre
                belépve néhány kattintás és kész is
                vagy az aláírással. Irány a képernyő
                bal oldalán található menüsorhoz és
                klikkelj az E-szerződések menüpontra.
                Itt válaszd ki a lista tetején található
                Aláírásra vár gombot. Jelöld ki a
                dokumentumot és Kattints a
                Megnyitás ikonra és így láthatod, hogy
                milyen dokumentumot küldtünk
                számodra. Olvasd át a kapott anyagot,
                ellenőrizd adataidat és ha mindent
                rendben találsz, akkor a lap alján az
                Aláírás gombra klikkelj. A rendszer a
                sikeres aláírásról küld egy e-mail
                értesítőt is és kész is vagyunk!
            </StepExpandableCard>
        </div>
    );
}

function StepExpandableCard({ icon, title, children, isOpen, onToggle }) {
    return (
        <div className="w-fit md:w-[340px] rounded-[2rem] bg-white shadow-2xl px-8 py-10 flex flex-col items-center text-center gap-4 transition-all duration-500">
            <img src={icon} alt="" className="w-24 h-24 object-contain" />

            <div className='flex flex-col gap-4'>
                <h3 className="font-display font-black text-2xl text-black leading-tight">
                    {title}
                </h3>

                <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${
                        isOpen ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
                    }`}
                >
                    <div className="text-sm md:text-base leading-relaxed text-black">
                        {children}
                    </div>
                </div>
            </div>

            <button
                type="button"
                onClick={onToggle}
                className="gradient-button-instructor text-white rounded-full size-12 flex items-center justify-center text-2xl font-black shadow-xl hover:scale-105 transition"
            >
                {isOpen ? <PiCaretUpBold /> : <PiCaretDownBold />}
            </button>
        </div>
    );
}